import { useState, useEffect, useRef } from 'react';
import { MessageSquare, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import Student1 from '../../Assets/Images/Feedback/FeedbackLogo.jpg';
import devavatar from '../../Assets/Images/Feedback/User-avatar.svg.png'
import './Feedback.css';

const Feedback = () => {
  const testimonials = [
    {
      img: devavatar,
      name: '',
      position: 'Участник',
      text: 'Хакатон мне очень понравился! За всю неделю я научился основам дизайна и вспомнил основы разработки',
      source: 'Участник',
      rating: 5
    },
    {
      img: devavatar,
      name: 'Александр',
      position: 'Участник',
      text: 'На хакатоне мне очень понравилось. Я могу сказать спасибо команде организаторов!',
      source: 'Участник',
      rating: 5
    },
    {
      img: devavatar,
      name: 'Мирослав',
      position: 'Участник',
      text: 'О хакатоне я могу сказать, что было круто! И мне понравилось на самом деле!',
      source: 'Участник',
      rating: 5
    },
    {
      img: devavatar,
      name: 'Анатолий',
      position: 'Участник',
      text: 'Такие мероприятия хотелось бы видеть чаще в нашем городе. Было очень интересно и за 8 дней получаешь больше опыта, чем за месяц обучения.',
      source: 'Участник',
      rating: 5
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const sliderRef = useRef(null);

  // Минимальное расстояние для свайпа
  const minSwipeDistance = 50; 

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    resetAutoPlay();
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    resetAutoPlay();
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    resetAutoPlay();
  };

  const resetAutoPlay = () => {
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 8000);
  };

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) nextSlide();
    if (isRightSwipe) prevSlide();
  };

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [testimonials.length, isAutoPlaying]);

  // Рендер рейтинга звездами
  const renderRating = (rating) => {
    return (
      <div className="rating-stars">
        {[...Array(5)].map((_, i) => (
          <span 
            key={i} 
            className={`star ${i < rating ? 'filled' : ''}`}
            aria-hidden="true"
          >
            {i < rating ? '★' : '☆'}
          </span>
        ))}
      </div>
    );
  };

  return (
    <section id="feedback" className="feedback-section">
      <div className="feedback-header">
        <MessageSquare className="header-icon" size={40} />
        <h1>Отзывы о нас</h1>
        <p className="header-subtitle">Реальные истории успеха наших студентов и партнеров</p>
      </div>
      
      <div 
        className="feedback-slider" 
        ref={sliderRef}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <button 
          className="slider-nav prev"
          onClick={prevSlide}
          aria-label="Предыдущий отзыв"
        >
          <ChevronLeft size={24} />
        </button>
        
        {testimonials.map((item, index) => (
          <div 
            key={index}
            className={`feedback-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ animation: index === currentSlide ? 'fadeInUp 0.8s ease' : 'none' }}
            aria-hidden={index !== currentSlide}
          >
            <div className="feedback-card">
              <div className="quote-icon">
                <Quote size={32} />
              </div>
              <p className="feedback-text">{item.text}</p>
              
              {renderRating(item.rating)}
              
              <div className="author-info">
                <img 
                  src={item.img} 
                  alt={item.name} 
                  className="author-avatar" 
                  width={60}
                  height={60}
                  loading="lazy"
                />
                <div className="author-details">
                  <span className="author-name">{item.name}</span>
                  {/* <span className="author-position">{item.position}</span> */}
                  <span className="source-badge">
                    {item.source}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
        
        <button 
          className="slider-nav next"
          onClick={nextSlide}
          aria-label="Следующий отзыв"
        >
          <ChevronRight size={24} />
        </button>
        
        <div className="slider-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Перейти к отзыву ${index + 1}`}
              aria-current={index === currentSlide}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Feedback;